export default "__VITE_ASSET__CRjNGXK8__"